"use strict";

/*==============================================================================
TRESTLE™ W003
TRESTLE Recommends
Version 2.0
==============================================================================*/

const W003={

/*==============================================================================
DOM
==============================================================================*/

ui:{

    foodPage:null,

    foodCard:null,

    exercisePage:null,

    exerciseCard:null

},

/*==============================================================================
INIT
==============================================================================*/

init(){

    this.cacheDOM();

    this.reset();

    console.log(

        "W003 Ready"

    );

},

/*==============================================================================
RESET
==============================================================================*/

reset(){

    this.renderFoodCard();

    this.renderExerciseCard();

},

/*==============================================================================
CACHE DOM
==============================================================================*/

cacheDOM(){

    this.ui.foodPage=

        document.getElementById(

            "trFoodPage"

        );

    this.ui.foodCard=

        document.getElementById(

            "trFoodCard"

        );

    this.ui.exercisePage=

        document.getElementById(

            "trExercisePage"

        );

    this.ui.exerciseCard=

        document.getElementById(

            "trExerciseCard"

        );

},

/*==============================================================================
LOAD PROFILE
==============================================================================*/

loadProfile(){

    const profile=

        localStorage.getItem(

            "trestleProfile"

        );

    if(

        !profile

    ){

        console.log(

            "No TRESTLE Profile Found"

        );

        return null;

    }

    try{

        const data=

            JSON.parse(

                profile

            );

        console.log(

            "TRESTLE Profile",

            data

        );

        return data;

    }

    catch(error){

        console.error(

            "Unable to read TRESTLE Profile",

            error

        );

        return null;

    }

},

/*==============================================================================
NORMALIZE KEY
==============================================================================*/

normalizeKey(value){

    if(

        !value

    ){

        return "";

    }

    return value

        .toLowerCase()

        .trim()

        .replace(/\s+/g,"_");

},

/*==============================================================================
GET FOOD RECOMMENDATION
Promise + Diabetes Profile
==============================================================================*/

getFoodRecommendation(){

    const profile=

        this.loadProfile();

    if(

        !profile

    ){

        return null;

    }

    const promise=

        this.normalizeKey(

            profile.promise

        );

    const diabetes=

        this.normalizeKey(

            profile.diabetesType

        );

    return(

        TRESTLE_FOOD_DATA?.[promise]?.[diabetes]||

        null

    );

},

/*==============================================================================
GET EXERCISE RECOMMENDATION
Promise + Life Stage
==============================================================================*/

getExerciseRecommendation(){

    const profile=

        this.loadProfile();

    if(

        !profile

    ){

        return null;

    }

    const promise=

        this.normalizeKey(

            profile.promise

        );

    const lifeStage=

        this.normalizeKey(

            profile.lifeStage

        );

    return(

        TRESTLE_EXERCISE_DATA?.[promise]?.[lifeStage]||

        null

    );

},

/*==============================================================================
RENDER FOOD CARD
==============================================================================*/

renderFoodCard(){

    if(

        !this.ui.foodCard

    ){

        return;

    }

    const food=

        this.getFoodRecommendation();

    if(

        !food

    ){

        this.renderFoodDefault();

        return;

    }

    this.ui.foodCard.innerHTML=

    `

    ${food.image ? `

    <img
    class="tr-food-image"
    src="${food.image}"
    alt="Food and drink recommendation">

    ` : ""}

    <div class="tr-food-content">

        <p class="tr-food-intro">

            ${food.intro || ""}

        </p>

        <div class="tr-food-item">

            <strong>Morning</strong>

            <p>

                ${food.morning || ""}

            </p>

        </div>

        <div class="tr-food-item">

            <strong>Midday</strong>

            <p>

                ${food.midday || ""}

            </p>

        </div>

        <div class="tr-food-item">

            <strong>Afternoon</strong>

            <p>

                ${food.afternoon || ""}

            </p>

        </div>

        <div class="tr-food-item">

            <strong>Before Leaving Work</strong>

            <p>

                ${food.beforeLeaving || ""}

            </p>

        </div>

        ${food.advisory ? `

        <div class="tr-food-advisory">

            ${food.advisory}

        </div>

        ` : ""}

    </div>

    `;

},

/*==============================================================================
RENDER EXERCISE CARD
==============================================================================*/

renderExerciseCard(){

    if(

        !this.ui.exerciseCard

    ){

        return;

    }

    const exercise=

        this.getExerciseRecommendation();

    if(

        !exercise

    ){

        this.renderExerciseDefault();

        return;

    }

    this.ui.exerciseCard.innerHTML=

    `

    ${exercise.image ? `

    <img
    class="tr-exercise-image"
    src="${exercise.image}"
    alt="Fitness recommendation">

    ` : ""}

    <div class="tr-exercise-content">

        <p class="tr-exercise-intro">

            ${exercise.intro || ""}

        </p>

        <div class="tr-exercise-item">

            <strong>Morning</strong>

            <p>

                ${exercise.morning || ""}

            </p>

        </div>

        <div class="tr-exercise-item">

            <strong>Midday</strong>

            <p>

                ${exercise.midday || ""}

            </p>

        </div>

        <div class="tr-exercise-item">

            <strong>Afternoon</strong>

            <p>

                ${exercise.afternoon || ""}

            </p>

        </div>

        <div class="tr-exercise-item">

            <strong>Before Leaving Work</strong>

            <p>

                ${exercise.beforeLeaving || ""}

            </p>

        </div>

        ${exercise.advisory ? `

        <div class="tr-exercise-advisory">

            ${exercise.advisory}

        </div>

        ` : ""}

    </div>

    `;

},

/*==============================================================================
FOOD DEFAULT
==============================================================================*/

renderFoodDefault(){

    this.ui.foodCard.innerHTML=

    `

    <div class="tr-w003-default">

        <p>

            Complete your TRESTLE Profile to view personalized food and drink recommendations.

        </p>

    </div>

    `;

},

/*==============================================================================
EXERCISE DEFAULT
==============================================================================*/

renderExerciseDefault(){

    this.ui.exerciseCard.innerHTML=

    `

    <div class="tr-w003-default">

        <p>

            Complete your TRESTLE Profile to view personalized movement recommendations.

        </p>

    </div>

    `;

}

};

/*==============================================================================
PROFILE UPDATE LISTENER
==============================================================================*/

window.addEventListener(

    "trestle-profile-updated",

    ()=>{

        W003.reset();

        console.log(

            "W003 Updated From TRESTLE Profile"

        );

    }

);

/*==============================================================================
BOOTSTRAP
==============================================================================*/

document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        W003.init();

    }

);